import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-ktostamm-lieferant-master-view',
  imports: [],
  templateUrl: './ktostamm-lieferant.master-view.html',
  styleUrls: ['./ktostamm-lieferant.master-view.css'],
})
export class KtostammLieferantMasterView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
